import { Box, genesisStyled, css } from '@leagueplatform/genesis-commons';

export const EmptyState = genesisStyled(Box)(
  css({
    backgroundColor: 'surface.background.secondary',
    textAlign: 'center',
  }),
);
